import { Pipe, PipeTransform } from '@angular/core';
import NiboWhatsAppConnection from './models/nibo-whatsapp-connection';
import { ConnectionTenantFilterConfig } from './components/connections-list/connections-list.component';

@Pipe({
  standalone: false,
  name: 'tenant'
})
export class TenantPipe implements PipeTransform {

 transform(value: NiboWhatsAppConnection[], arg: ConnectionTenantFilterConfig[]): NiboWhatsAppConnection[] {
     const filter = arg.filter(a => a.checked);
     return value.filter(conn => {
       if (!conn.tenant)
         return true;
       return filter.some(a => a.value.id === conn.tenant?.id);
     })
   }

}
